import React from "react";

import {
  defaultGapping,
  defaultLayouts,
  defaultPadding,
  defaultTypography,
  GSImage,
  GSItemList,
  useMediaQuery,
} from "golfstatus_react_components";

import { useSelector } from "react-redux";
import { useTournament } from "../../hooks/tournamentHooks";
import { selectTournamentSponsors } from "../../reducers/tournamentSlice";
import { useTheme } from "../../hooks/themeHooks";
import { getRoundsSummary } from "../events/event-details-item";

const TVLeaderboardsSponsorsWidget = (props) => {
  const { style } = props;
  const [, theme, getStyle] = useTheme();
  const tournament = useTournament();
  const sponsorships = useSelector(selectTournamentSponsors);

  const techSponsors = sponsorships.filter(
    (sponsor) => sponsor.sponsorshipType === "leaderboard"
  );

  const { isPhone, innerWidth } = useMediaQuery();

  const tablet  = innerWidth <= 900
  const phone =  isPhone();

  const sponsorLayoutDirection = phone || tablet
    ? defaultLayouts.hStack.align("center","center")
    : { ...defaultLayouts.vStack.align("flex-start","center"), height: "100%", maxWidth: "300px" };

  const { tournamentFormats, tournamentRounds } = tournament;

  const { facilityName, city, state } = getRoundsSummary(
    tournamentRounds,
    tournamentFormats
  );

  const getTournamentInfo = () => {
    if(phone || tablet){
      return 
    }
    return <div
    style={{
      ...defaultLayouts.fullWidth,
      ...defaultLayouts.vStack.align("flex-start", "flex-start"),
      ...defaultGapping.noGap
    }}
  >
    <div
      style={{
        ...defaultLayouts.fullWidth,
        ...defaultTypography.headline3,
      }}
    >
      {tournament.name}
    </div>
    <div
      style={{
        ...defaultLayouts.fullWidth,
        ...defaultTypography.bodyRegular.withOpacity(),
      }}
    >
      {facilityName}
    </div>
    <div
      style={{
        ...defaultLayouts.fullWidth,
        ...defaultTypography.bodyRegular.withOpacity(),
      }}
    >{`${city}, ${state}`}</div>
  </div>
  }

  return (
    <div
      style={{
        ...defaultPadding.xLargePad,
        ...sponsorLayoutDirection,
        ...defaultGapping.largeGap,
        ...getStyle(theme.surfaceVariant),
        ...style,
      }}
      className="sponsor-list"
    >
      {getTournamentInfo()}
      <GSImage
        size={phone || tablet ? "small" : "medium"}
        ratio="wide"
        src={tournament.logo}
      />
      {techSponsors?.length > 0 ||
      tournament?.tournamentPromotion?.secondaryLeaderboardPhoto ? (
        <>
          <GSItemList
            items={techSponsors}
            listItem={(s) => (
              <div style={{ ...defaultLayouts.vStack }}>
                <GSImage
                  size={phone || tablet ? "small" : "medium"}
                  ratio="wide"
                  src={s.logo}
                />
              </div>
            )}
          />
          {tournament?.tournamentPromotion?.secondaryLeaderboardPhoto ? (
            <GSImage
              size={phone || tablet ? "small" : "medium"}
              ratio="wide"
              src={tournament?.tournamentPromotion?.secondaryLeaderboardPhoto}
            />
          ) : null}
        </>
      ) : null}
      {!phone && !tablet ? 
      <div style={{...defaultTypography.bodyRegular.withOpacity()}}>Leaderboards update automatically</div>: null}
      
    </div>
  );
};

export default TVLeaderboardsSponsorsWidget;
